import React from "react";

interface PageHeroProps {
  badge?: string;
  children: React.ReactNode;
}

export const PageHero = ({ badge, children }: PageHeroProps) => (
  <section
    className="relative overflow-hidden px-6 py-16 lg:px-10 lg:py-20"
    style={{
      background:
        "linear-gradient(155deg, hsl(37,88%,96%) 0%, hsl(39,82%,92%) 50%, hsl(42,86%,78%) 100%)",
    }}
  >
    
    <div className="relative mx-auto max-w-4xl">
      {badge && (
        <span className="mb-5 inline-block rounded-full bg-primary px-4 py-1.5 text-sm font-semibold text-primary-foreground">
          {badge}
        </span>
      )}
      <h1 className="font-display text-4xl font-bold leading-tight text-secondary md:text-5xl lg:text-6xl">
        {children}
      </h1>
    </div>
  </section>
);
